module.exports = __webpack_public_path__ + "media/images/strategic-partners/new/FlexScanMD-a7992876b6a7dd416f21eb81978a7cfe.png";